var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M21.565 21.566a1.212 1.212 0 0 1-1.72-.006c-1.562-1.58-4.807-4.86-5.79-5.843a7.598 7.598 0 0 1-10.237-1.21 7.576 7.576 0 0 1 .407-10.288 7.598 7.598 0 0 1 10.3-.4 7.576 7.576 0 0 1 1.205 10.225l5.834 5.805c.476.473.476 1.242 0 1.717zm-12-17.255a5.27 5.27 0 0 0-5.268 5.27 5.27 5.27 0 0 0 5.275 5.264 5.27 5.27 0 0 0 5.271-5.267A5.273 5.273 0 0 0 9.565 4.31z","fill":"#F60"}));
}

Search.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Search;

Search.default = Search;
